var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-alarm-actions-chips',_vm._g({attrs:{"items":_vm.filteredTags,"active-items":_vm.selectedTags,"small":_vm.small,"inline-count":_vm.inlineCount,"closable-active":_vm.closableActive,"item-class":"c-alarm-tags-chips__chip","item-text":"value","item-value":"value","row":""}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }